<template>
  <div class="receipt-new">
    <div class="wrap">
      <print
        size="A4"
        :data="mixData"
        :template="tpl"
        class="print-container"
        ref="print"
        v-if="tpl"
      ></print>
    </div>
    <div class="tips">
      <div class="txt">点击下方按钮，复制链接，用电脑浏览器打开，即可编辑收据样式。</div>
      <div class="copy">
        <input type="text" v-model="copyVaule" class="copy-input" ref="copyInput" />
        <van-button square round type="primary" block @click="copyUrl">复制链接</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import print from '@teacher/components/print.vue';
export default {
  name: 'sf-set-receipt-example',
  data() {
    return {
      pageTitle: '收据样式设置',     
      copyVaule: '',
      mixData: null,
      tpl: null,
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
  },
  mounted() {
    this.getImportUrl();
    this.getPayData();
  },
  methods: {
    // 复制
    copyUrl() {
      this.$refs.copyInput.select();
      this.$refs.copyInput.setSelectionRange(0, this.copyVaule.length);
      document.execCommand('copy');
      vant.Toast.success('复制成功');
      this.$refs.copyInput.blur();
    },
    // 获取PC端收据打印地址
    getImportUrl() {
      let host = `${location.origin}`;
      if (process.env.VUE_APP_x3_env === 'prod') {
        host = 'https://yunxiao.xiaogj.com';
      }
      this.copyVaule = `${host}/web/teacher/index.html${location.search}#/print-template`;
    },
    // 获取支付信息
    async getPayData() {
      this.showLoading();
      let company = this.userInfo.companyInfoVo
      

      const result = await this.$api.receiptTemplateInfo({
        receiptType: 0,
      });
      vant.Toast.clear();
      const config = {};
      result.data.details.forEach(item => {
        Object.assign(config, {
          [item.fieldName]: item,
        });
      });

      // 强制不显示
      if (!result.data.valueAdd) {
        config.LOGO.display = false;
        config.OFFICIAL_SEAL.display = false;
      }
      config.LOGO.fieldVal = config.LOGO.fieldVal === '' ? {} : JSON.parse(config.LOGO.fieldVal);
      config.OFFICIAL_SEAL.fieldVal =
        config.OFFICIAL_SEAL.fieldVal === '' ? {} : JSON.parse(config.OFFICIAL_SEAL.fieldVal);
      const code = await this.$api.getWxMpCode();

      const layout = JSON.parse(result.data.layout);
      const transA4Receipt = eval(`(${layout.A4.transFn})`);  
      const previewData = transA4Receipt(layout.A4.exampleData, company, {
        getGoodsShowName: app.x3.tool.getGoodsShowName,
        formatNumber: app.tool.formatNumber,
        formatDatetime: app.tool.date.formatDatetime,
      });
      this.mixData = {
        config,
        data: { ...previewData, QRCODE_URL: code.data },
      };
      this.tpl = layout.A4.html;
    },
  },
  components: {
    print,
  },
};
</script>

<style lang="scss" scoped>
.receipt-new {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .wrap {
    flex: 1 1 auto;
    width: 100%;
    overflow: auto;
  }
  .tips {
    flex:0 0 auto;
    padding: calc(var(--gap) * 20) calc(var(--gap) * 16);
    .txt {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
      padding-bottom: calc(var(--gap) * 12);
    }
  }
  .copy {
    position: relative;
    .copy-input {
      position: absolute;
      opacity: 0;
    }
  }
}
</style>

